import CssClasses from '../../template/common/cssClasses';

export default function injectStyles() {
  const css = `
    <style type="text/css">
      .${CssClasses.orderDiscount} {
          font-weight: bold !important;
          color: black !important;
      }
      ${CssClasses.originalPriceAttribute} {
        font-size: 0.92em;
      }
      .${CssClasses.subtotalPriceBlock} {
        display: inline-flex;
        flex-direction: column;
        padding-left: 60px;
      }
      .${CssClasses.hidden}{ 
        display: none; 
      }
    </style>
  `;

  document.querySelector('head').insertAdjacentHTML('beforeend', css);
}
